import { formatDistance } from 'date-fns';

export default function DaysAgo({ date }: { date: string | Date }) {
  return <>{formatDistance(date, new Date(), { addSuffix: true })}</>;
}
